module.exports = __webpack_public_path__ + "img/shh_metalwarmint.ea0b44c.png";